// Zod runtime configuration, imported first by main.tsx: jitless parsing, so Zod never probes eval and the strict CSP stays clean.
import { z } from "zod";

z.config({ jitless: true });
